import { NOT_OK_HEARTBEAT, OK_HEARTBEAT } from '../config'
import { useCurrentBlock } from './use-current-block'
import { useEffect, useState } from 'react'
import { isDocumentVisible } from '../utils/document-visibility'

export interface ProviderStatus {
  outdated: boolean
  count: number
}
export function useProviderStatusState(): ProviderStatus {
  const [checkInterval, setCheckInterval] = useState<number>(NOT_OK_HEARTBEAT)
  const { nonce, currentBlockTimestamp } = useCurrentBlock(checkInterval)

  const [outdated, setOutdated] = useState<boolean | undefined>(undefined)
  const [initialTolerance, setInitialTolerance] = useState(true)
  const [count, setCount] = useState(0)

  useEffect(() => {
    setTimeout(() => {
      setInitialTolerance(false)
    }, 3000) // After 3 seconds, we should not accept missing block
  }, [])

  useEffect(() => {
    if (!currentBlockTimestamp) {
      if (!initialTolerance) {
        setOutdated(true)
      }
      return
    }

    const machineTime = Date.now()
    // Delay is in seconds
    const delay = machineTime - currentBlockTimestamp

    let isOutdated = delay > OK_HEARTBEAT - NOT_OK_HEARTBEAT

    // For local tests
    //isOutdated = Math.random() > 0.5

    setOutdated(isOutdated)
    if (outdated && isDocumentVisible()) {
      setCount(count + 1)
    } else {
      if (count !== 0) {
        setCount(0)
      }
    }
  }, [nonce])

  useEffect(() => {
    if (outdated) {
      // If we encounter the first problem, then we check ten seconds later
      setCheckInterval(count === 1 ? 10_000 : NOT_OK_HEARTBEAT)
    } else {
      // We have a different delay and will adjust the healthCheck
      // The bigger the delay, the smaller the healthcheck
      const machineTime = Date.now()
      const delay = machineTime - currentBlockTimestamp

      const limitOfTime = OK_HEARTBEAT - delay
      setCheckInterval(Math.floor(limitOfTime))
    }
  }, [outdated])

  if (!currentBlockTimestamp || outdated === undefined) {
    // if we are in the tolerance time, then it's not outdated

    return {
      outdated: initialTolerance!,
      count,
    }
  }

  return { outdated, count }
}
